import React from 'react';
import { Box } from '@mui/material';
import packageJson from '../../package.json'; // Default Import


const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#f0f0f0',
                px: '20px',
                mt: '20px',
                textAlign: 'center',
                borderTop: '1px solid #ddd',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                height: '50px'
            }}
        >
            <div>
                <a href="/impressum" style={{ textDecoration: 'none', color: '#333' }}>
                    Impressum
                </a>
            </div>
            <div style={{ color: '#666' }}>
                Version {packageJson.version}
            </div>
        </Box>
    );
};

export default Footer;